import {
  NavigateEditPageButton,
  PageContent,
  PageHeader,
  Space,
} from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useLocation } from 'react-router';
import {
  CreateOrganizationPage,
  CreateRolePage,
  CreateUserPage,
  HierarchyLabelsPage,
  OrganizationActionsButton,
  OrganizationDetailsPage,
  ResetPasswordPage,
  RoleActionsButton,
  RoleDetailsPage,
  TenantManagerRootPage,
  UpdateOrganizationPage,
  UpdateRolePage,
  UpdateUserButton,
  UpdateUserPage,
  UserActionsButton,
  UserDetailsPage,
} from './components';
import { CreateHierarchyLabelButton } from './components/CreateHierarchyLabelButton';
import { HierarchyLabelsDrawerStateProvider } from './components/hierarchy-label/DrawerStateProvider';
export const AdminRoutes = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Routes>
      <Route
        index
        element={
          <>
            <PageHeader
              title={t('tenant-manager-root-page')}
              breadcrumbs={[{ title: t('tenant-manager-root-page') }]}
              // buttons={
              //   <TenantManagerResourceGuard>
              //     <NavigateButton
              //       path="label"
              //       text={t('hierarchy-labels-page')}
              //     />
              //   </TenantManagerResourceGuard>
              // }
            />
            <PageContent>
              <TenantManagerRootPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/users/new"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('create-user-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                { title: t('create-user-page') },
              ]}
            />
            <PageContent>
              <CreateUserPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/users/:id"
        element={
          <>
            <PageHeader
              title={t('user-details-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                { title: t('user-details-page') },
              ]}
              buttons={
                <TenantManagerResourceGuard onlyEdit>
                  <Space>
                    <UpdateUserButton />
                    <UserActionsButton />
                  </Space>
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <UserDetailsPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/users/:id/edit"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('update-user-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                {
                  title: t('user-details-page'),
                  href: `${location.pathname
                    .split('/')
                    .slice(0, -1)
                    .join('/')}`,
                },
                { title: t('update-user-page') },
              ]}
            />
            <PageContent>
              <UpdateUserPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/users/:id/reset-password"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('reset-password')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                {
                  title: t('user-details-page'),
                  href: `${location.pathname
                    .split('/')
                    .slice(0, -1)
                    .join('/')}`,
                },
                { title: t('reset-password') },
              ]}
            />
            <PageContent>
              <ResetPasswordPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/organizations/new"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('create-organization-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager?activeKey=organizations',
                },
                { title: t('create-organization-page') },
              ]}
            />
            <PageContent>
              <CreateOrganizationPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/organizations/:id"
        element={
          <>
            <PageHeader
              title={t('organization-details-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager?activeKey=organizations',
                },
                { title: t('organization-details-page') },
              ]}
              buttons={
                <TenantManagerResourceGuard onlyEdit>
                  <Space>
                    <NavigateEditPageButton />
                    <OrganizationActionsButton />
                  </Space>
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <OrganizationDetailsPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/organizations/:id/edit"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('update-organization-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager?activeKey=organizations',
                },
                {
                  title: t('organization-details-page'),
                  href: `${location.pathname
                    .split('/')
                    .slice(0, -1)
                    .join('/')}`,
                },
                { title: t('update-organization-page') },
              ]}
            />
            <PageContent>
              <UpdateOrganizationPage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/roles/new"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('create-role-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager?activeKey=roles',
                },
                { title: t('create-role-page') },
              ]}
            />
            <PageContent>
              <CreateRolePage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/roles/:id"
        element={
          <>
            <PageHeader
              title={t('role-details-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager?activeKey=roles',
                },
                { title: t('role-details-page') },
              ]}
              buttons={
                <TenantManagerResourceGuard onlyEdit>
                  <Space>
                    <NavigateEditPageButton />
                    <RoleActionsButton />
                  </Space>
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <RoleDetailsPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/roles/:id/edit"
        element={
          <TenantManagerResourceGuard onlyEdit showDenied>
            <PageHeader
              title={t('update-role-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager?activeKey=roles',
                },
                {
                  title: t('role-details-page'),
                  href: `${location.pathname
                    .split('/')
                    .slice(0, -1)
                    .join('/')}`,
                },
                { title: t('update-role-page') },
              ]}
            />
            <PageContent>
              <UpdateRolePage />
            </PageContent>
          </TenantManagerResourceGuard>
        }
      />
      <Route
        path="/label"
        element={
          <HierarchyLabelsDrawerStateProvider>
            <PageHeader
              title={t('hierarchy-labels-page')}
              breadcrumbs={[
                {
                  title: t('tenant-manager-root-page'),
                  href: '/tenant-manager',
                },
                { title: t('hierarchy-labels-page') },
              ]}
              buttons={
                <TenantManagerResourceGuard onlyEdit>
                  <CreateHierarchyLabelButton />
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <HierarchyLabelsPage />
            </PageContent>
          </HierarchyLabelsDrawerStateProvider>
        }
      />
    </Routes>
  );
};
